import { useEffect, useState } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import axiosInstance from "services/axiosInstance";
import * as S from "./styled";
/**
 * Hooks
 */
import useLoading from "../../../../hooks/useLoading";
import apiRequest from "../../../../hooks/apiRequest";
/**
 * Components
 */
import LayoutModal from "../../../LayoutModal";
import CreditCard from "../../Payment/CreditCard";
/**
 * Inteface
 */
import { Inputs } from "Interfaces/IPayCredit";
import { IMethPay } from "Interfaces/IMethodPaym";
/**
 * Utils
 */
import { HandleSelectedPayment } from "utils/FunctionPayment";
import { CurrencyFormat } from "utils/CurrencyFormat";

interface ICreate {
  isOpenModalCustomer: boolean;
  setModalClose: () => void;
  refreshFrames: () => void;
  selectedId: number | null;
  selectedIdCredit: number | null;
  total: string;
}

export default function PayInvoice({
  isOpenModalCustomer,
  setModalClose,
  refreshFrames,
  selectedId,
  selectedIdCredit,
  total,
}: ICreate) {
  const {
    register,
    control,
    reset,
    resetField,
    handleSubmit: handleFormSubmit,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();
  const [formPay, setFormPay] = useState<IMethPay[]>([]);
  const [formPaymentSelec, setFormPaymentSelec] = useState("");

  //Cadastrar
  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const payload = {
        card_id: data.card_id?.find((val) => val) || null,
        amount: data.amount,
        form_payment_id: data.form_payment_id,
        payment_credit_id: selectedIdCredit,
        status: "Pago",
      };

      if (payload.amount > total || payload.amount < total) {
        return alert(
          "Valor digitado incompatível com a parcela atual! Por favor, insira o valor correto."
        );
      } else {
        const response = await apiRequest<Inputs>(
          `installment/${selectedId}`,
          "PATCH",
          payload
        );

        if (response.status === 200) {
          alert("Pagamento realizado com sucesso!");
          refreshFrames();
          setModalClose();
        }
      }
    } catch (error: any) {
      alert(
        error.message ||
        "Ocorreu um erro ao processar o pagamento. Tente novamente."
      );
    } finally {
      stopLoading();
    }
  };

  const onClose = () => {
    setModalClose();
    reset();
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get("payment-method");
        const paymentData = response.data;

        const FilterPayment = paymentData.filter(
          (payment: IMethPay) =>
            payment.payment_method !== "Pag. Combinado" &&
            payment.payment_method !== "Crediário da Loja"
        );

        setFormPay(FilterPayment);
      } catch (error) {
        console.error("Erro ao obter dados:", error);
      }
    };

    fetchData();
  }, []);

  const ModalSelectedPayment = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const result = HandleSelectedPayment(event);

    if (typeof result === "object") {
      const { id, name } = result;

      setFormPaymentSelec(name);
    } else {
      console.log("Nenhum pagamento selecionado.");
    }
  };

  if (isOpenModalCustomer) {
    return (
      <LayoutModal
        statusLoad={isLoading}
        title="Pagar Fatura"
        subTitle="Informe o valor e a forma de pagamento da fatura."
        setModalClose={onClose}
        submiteModal={handleFormSubmit(onSubmit)}
        nameSubmit="Pagar"
      >
        <S.Container>
          <S.Header>
            <S.Title>
              <span>Total da Parcela</span>
              {CurrencyFormat(parseFloat(total) || 0)}
            </S.Title>
          </S.Header>
          <S.SeparateDiv>
            <S.FormInput>
              <S.Label>
                Forma de Pagamento
                <span>*</span>
              </S.Label>

              <S.Select
                {...register("form_payment_id", { required: true })}
                onChange={(e) => ModalSelectedPayment(e)}
              >
                <option value="" disabled selected hidden>
                  Selecione
                </option>
                {formPay.map((val) => {
                  return <option value={val.id}>{val.payment_method}</option>;
                })}
              </S.Select>
              {errors.form_payment_id && (
                <S.InforErro>Campo Obrigatório</S.InforErro>
              )}
            </S.FormInput>

            <S.FormInput>
              <S.Label>
                Valor
                <span>*</span>
              </S.Label>
              <Controller
                name="amount"
                control={control}
                rules={{ required: "Campo é obrigatório" }}
                render={({ field: { onChange, value, ref } }) => (
                  <NumericFormat
                    className="InputDiscout"
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    fixedDecimalScale={true}
                    placeholder="R$ 0,00"
                    prefix="R$ "
                    value={value}
                    onValueChange={(values) => {
                      const purchaseValue = values.floatValue ?? 0;
                      onChange(purchaseValue);
                    }}
                    getInputRef={ref}
                  />
                )}
              />
              {errors.amount && <S.InforErro>Campo Obrigatório</S.InforErro>}
            </S.FormInput>
          </S.SeparateDiv>

          {formPaymentSelec === "credit-card" && (
            <CreditCard
              register={register}
              errors={errors}
              reset={reset}
              resetField={resetField}
              subtotal={10}
            />
          )}
        </S.Container>
      </LayoutModal>
    );
  }
  return null;
}
